function openImageFullscreen(imageToOpen) {
  const fullscreenImageContainer = document.getElementById('fullscreenImageContainer');
  if (imageToOpen) {
    fullscreenImageContainer.innerHTML = `
        <img src="${imageToOpen}" alt="test" fetchpriority="high" loading="eager"/>
      `;
  }
  document.body.classList.toggle('overflow-hidden');
  fullscreenImageContainer.classList.toggle('hidden-block');
}
function updateAddToCartCopy(isSignature) {
  const addToCartCopy = document.querySelector('#add-to-cart-copy');
  if (addToCartCopy == null) return;
  const label = isSignature ? 'Subscribe' : 'Add to cart';
  const price = isSignature ? addToCartCopy.dataset.subscribePrice : addToCartCopy.dataset.onetimePrice;
  addToCartCopy.innerHTML = price ? `${label} · ${price}` : label;
}
window.updateAddToCartCopy = updateAddToCartCopy;

function handleSignatureIntent(addToSignature) {
  const paymentDefault = document.getElementById('payment-method-default');
  const paymentPrime = document.getElementById('payment-method-signature');
  const paymentDefaultContainer = document.getElementById('payment-default');
  const paymentSignatureContainer = document.getElementById('payment-signature');
  const productImage = document.querySelectorAll('.main-product-image')
  const productCustomImage = document.querySelectorAll('.main-product-custom-image')
  const flavorBoxImages = document.querySelectorAll('.flavor_box_image_default')
  const flaverBoxCustomImages = document.querySelectorAll('.flavor_box_image_custom')
  const singlePurchaseBenefits = document.querySelector('.single-purchase-benefit-container');
  const signatureBenefits = document.querySelector('.prime-benefit-container');
  if (addToSignature) {
    signatureBenefits?.classList.remove('collapse');
    singlePurchaseBenefits?.classList.add('collapse');
    addToSubscription(true)
    flavorBoxImages.forEach((flavor) => flavor.classList.add("hidden"));
    flaverBoxCustomImages.forEach((flavor) => {
      flavor.classList.remove("hidden");
    });
    productImage.forEach((image) => image.classList.add('hidden'))
    productCustomImage.forEach((image) => image.classList.remove('hidden'))
    paymentDefaultContainer?.classList.remove('b-343a40')
    paymentSignatureContainer?.classList.add('b-343a40')
    updateAddToCartCopy(true)
    if (paymentPrime != null) {
      paymentPrime.click();
    }
  } else {
    flavorBoxImages.forEach((flavor) => {
      flavor.classList.remove("hidden");
    });
    flaverBoxCustomImages.forEach((flavor) => {
      flavor.classList.add("hidden");
    });
    signatureBenefits?.classList.add('collapse');
    singlePurchaseBenefits?.classList.remove('collapse');
    addToSubscription(false)
    productImage.forEach((image) => image.classList.remove('hidden'))
    productCustomImage.forEach((image) => image.classList.add('hidden'))
    paymentDefaultContainer.classList.add('b-343a40')
    paymentSignatureContainer.classList.remove('b-343a40')
    updateAddToCartCopy(false)
    if (paymentDefault != null) {
      paymentDefault.click();
    }
  }
}

  function setPPBQuantity(quantity){
    const quantityInput = document.querySelector(".quantity__input-ppb");
    if(quantityInput != null){
      quantityInput.value = quantity
    }
   
    const allQuantityButtons = document.querySelectorAll(".quantity__button-ppb");
    if(allQuantityButtons != null && allQuantityButtons.length > 0){
      allQuantityButtons.forEach(button => {
        if(button.id === `item-ppb_${quantity}`){
          button.classList.add("format_active")
        }else{
          button.classList.remove("format_active")
        }
      })
    }
  }